import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { PlatformAuthContext } from "context/PlatformAuthContext";
import PlatformHeader from "./PlatformHeader";
import PlatformAdminSidebar from "./PlatformAdminSidebar";
import PlatformFooter from "./PlatformFooter";

interface PlatformLayoutProps {
 children: React.ReactNode;
 showHeader?: boolean;
 headerSticky?: boolean;
}

const PlatformLayout: React.FC<PlatformLayoutProps> = ({ 
 children, 
 showHeader = true,
 headerSticky = true 
}) => {
 const location = useLocation();
 // Safely access context - returns undefined if provider is not available (public pages)
 const authContext = useContext(PlatformAuthContext);
 const isAuthenticated = authContext?.isAuthenticated || false;
 const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
 const isPlatformAdminRoute = location.pathname.startsWith("/platform/") && 
  !location.pathname.startsWith("/platform/login") && 
  location.pathname !== "/platform/";

 // Scroll to top on route change
 useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
 }, [location.pathname]);

 // For platform admin routes, show sidebar instead of header
 if (isPlatformAdminRoute && isAuthenticated) {
  return (
   <div className="min-h-screen bg-gray-50 flex flex-col">
    <div className="flex flex-1">
     <PlatformAdminSidebar 
      isCollapsed={sidebarCollapsed} 
      onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
     />
     <main className={`flex-1 transition-all duration-300 ${
      sidebarCollapsed ? "lg:ml-20" : "lg:ml-64"
     }`}>
      <div className="p-6">
       {children}
      </div>
     </main>
    </div>
    <PlatformFooter />
   </div>
  );
 }

 // For public platform pages
 return (
  <div className="min-h-screen bg-white flex flex-col">
   {showHeader && <PlatformHeader isSticky={headerSticky} />}
   <main className={`flex-1 ${showHeader && headerSticky ? "pt-0" : ""}`}>
    {children}
   </main>
   <PlatformFooter />
  </div>
 );
};

export default PlatformLayout;
